export const SIZE = {
  small: { name: "30 см", price: 200 },
  large: { name: "35 см", price: 250 },
};

export const DOUGH = {
  thin: { name: "Тонкое", price: 0 },
  lush: { name: "Толстое", price: 0 },
};

export const SAUCE = {
  tomatosauce: { name: "Томатный", price: 0 },
  mayo: { name: "Майонез", price: 0 },
  spicy: { name: "Острый", price: 0 },
  mash: {name: "Грибной", price: 0},
  garlic: {name: "Чесночный", price: 0},
  sweetandsour: {name: "Кисло-сладкий", price: 0},
  mustard: {name: "Горчичный", price: 0}
};